import { Component, Input } from '@angular/core';
import { Card } from 'src/app/models/card.model';
import { environment } from 'src/environments/environment';
import { CardType } from '../../../enums/card-type.enum';
import { Currency } from './../../../enums/currency.enum';

@Component({
  selector: 'lns-bank-card',
  templateUrl: './bank-card.component.html',
  styleUrls: ['./bank-card.component.scss']
})
export class BankCardComponent {
  @Input() bankCardData: Card | undefined;
  cardType = CardType;
  currency = Currency;
  environment = environment;
}
